// extracted by mini-css-extract-plugin
export default {"logoRussia":"navBar_logoRussia__MR9Z3"};